import { render, staticRenderFns } from "./Preanestecia.vue?vue&type=template&id=5908cb35&scoped=true"
import script from "./Preanestecia.vue?vue&type=script&lang=js"
export * from "./Preanestecia.vue?vue&type=script&lang=js"
import style0 from "./Preanestecia.vue?vue&type=style&index=0&id=5908cb35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5908cb35",
  null
  
)

export default component.exports